/**
 * GDPR Cookie Bar and GPC Policy control
 */
class gdprCookiebar {
  constructor() {
    this.nonEssential = 'linkedin, hotjar, iiintent, pardot, googleanalytics';
    this.cookieName = 'oe_user_cookie_consent';
    this.verifySettings();
    this.setEventListeners();
  }

  /**
   * Set event listeners for cookie bar buttons and modal save
   */
  setEventListeners() {
    const quickButtons = document.querySelectorAll(`button[data-gdpr-type]`);
    const modalSave = document.getElementById('js-cc-modal-save');
    const footerModalLink = document.querySelector('.js-cc-footer-link');
    const isNonEssentialEnabled = document.getElementById('non-essential-cookies');

    quickButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        const consentType = event.target.dataset.gdprType;
        this.storeCookieSettings(consentType);
      }.bind(this));
    });
    if(modalSave){
      modalSave.addEventListener('click', function() {
        const consentType = isNonEssentialEnabled.checked ? 'all' : '';
  
        this.storeCookieSettings(consentType);
      }.bind(this));
    }

    if(footerModalLink){
      footerModalLink.addEventListener('click', function(event) {
        event.preventDefault();
  
        // Set state of non essential cookie toggle based off user selection
        isNonEssentialEnabled.checked = gdprCookiebar.getCookie(this.cookieName) !== '';
  
        jQuery(function ($) {
          $('#cookie-consent-modal').modal('show');
        });
      }.bind(this));
    }
  }

  /**
   * On init, check if user has GPC enabled. If not then we check if user has a prior cookie choice and decided whether
   * to display the cookie bar or not
   */
  verifySettings() {
    if (gdprCookiebar.hasGPC() !== undefined) {
      this.setGPCConsent();
    } else if (gdprCookiebar.getCookie(this.cookieName) === false) {
      gdprCookiebar.setCookie(this.cookieName, this.getDefaultCookieValue());
    }

    this.displayCookieBar(gdprCookiebar.hasApprovedCookies());
  }

  /**
   * Display cookie bar control. Based off if user has accepted cookies or not. If GPC is enabled then no bar will be
   * displayed
   * @param hasCookies
   */
  displayCookieBar(hasCookies) {
    const cookieBar = document.querySelector('.js-cookie-consent');
    let display = 'block';

    if (hasCookies) {
      display = 'none';
    }

    cookieBar.style.display = display;
  }


  /**
   * User has GPC capable browser or extension. We need to check their set consent level.
   * If the user has not set their consent level we are assuming they are opted in per
   * GPC implementation PDF which will allow all tracking cookies to load unless they
   * are in the EU which will require them to opt in from the cookie banner
   */
  setGPCConsent() {
    const userConsentLevel = navigator.globalPrivacyControl ? "Y" : "N";
    const uspFramework = {
      version: 1,
      notice: "Y",
      optOut: userConsentLevel,
      lspa: "Y"
    }
    const uspString = Object.values(uspFramework).reduce((a, c) => { return a+c });

    window.__uspapi = (command, version, callback) => {
      if (command === "getUSPData" && version === 1) {
        callback(uspString, true);
      }
    }

    if (!gdprCookiebar.getCookie("openeye_cookie_consent")) {
      gdprCookiebar.setCookie(this.cookieName, this.getDefaultCookieValue(userConsentLevel));
    }
  }

  /**
   * Callback method for setting the cookies necessary value
   * @param type
   */
  storeCookieSettings(consentType) {
    gdprCookiebar.setCookie('openeye_cookie_consent', 1);
    gdprCookiebar.setCookie(this.cookieName, consentType === 'all' ? this.nonEssential:'');

    this.displayCookieBar(true);
  }

  /**
   * Get default cookie value. If the user is in the EU then we need to be sure to
   * follow GDPR and have no tracking cookies enabled by default. This method will
   * check and return a blank string if user has not opted in from the EU. If the
   * user is in the US it will be default be opted into tracking until the user
   * opts out
   *
   * @param gpcConsentLevel
   * return string
   */
  getDefaultCookieValue(gpcConsentLevel = "N") {
    return navigator.languages.includes("en-US") && gpcConsentLevel === "N" ? this.nonEssential : "";
  }

  /**
   * Check if user has GPC enabled browser or extension
   * @returns bool | undefined
   */
  static hasGPC() {
    return navigator.globalPrivacyControl;
  }

  /**
   * Method for checking if cookies are present on load. If so then it wont display the banner
   * @returns {boolean}
   */
  static hasApprovedCookies() {
    return this.getCookie('openeye_cookie_consent');
  }

  /**
   * Method for getting cookie by name
   * @param cookieName
   * @returns {boolean}
   */
  static getCookie(cookieName) {
    // Split cookie string and get all individual name=value pairs in an array
    let cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (let i = 0; i < cookieArr.length; i++) {
      let cookiePair = cookieArr[i].split("=");

      // Removing whitespace at the beginning of the cookie name and compare it with the given string
      if (cookieName === cookiePair[0].trim()) {
        // Found the cookie name. Return true to not create a new cookie
        return cookiePair[1];
      }
    }

    // Return false if not found
    return false;
  }

  /**
   * Create cookie with specified name and value
   * @param name
   * @param value
   */
  static setCookie(name, value = '') {
    const expireDate = this.getDate();

    document.cookie = `${name}=${value};expires=${expireDate};`;
  }

  /**
   * Create expiration date
   * @returns {string}
   */
  static getDate() {
    const date = new Date();
    const cookieExpiration = 30;

    date.setTime(date.getTime() + (cookieExpiration * 24 * 60 * 60 * 1000));

    return date.toUTCString();
  }
}

new gdprCookiebar();